'use client'
import {ProductCategory} from "@/modules/classes/products/ProductCategories";
import {JSX} from "react";
import {Disclosure} from "@headlessui/react";
import {MinusSmallIcon, PlusSmallIcon} from "@heroicons/react/24/outline";


export default function ProductFAQComponent(productCategory: ProductCategory): JSX.Element  {

    return (
        <dl className="max-w-3xl">
            {productCategory.questions.map((faq) => (
                <Disclosure as="div" key={faq.question} className="pt-6">
                    {({open}) => (
                        <>
                            <dt>
                                <Disclosure.Button
                                    className="flex w-full items-start justify-between text-left">
                                    <span className="text-base font-bold text-gray-500 ">{faq.question}</span>
                                    <span className="ml-6 flex h-7 items-center">
                                                                             {open ? (
                                                                                 <MinusSmallIcon className="h-6 w-6"
                                                                                                 aria-hidden="true"/>
                                                                             ) : (
                                                                                 <PlusSmallIcon className="h-6 w-6"
                                                                                                aria-hidden="true"/>
                                                                             )}
                                                                        </span>
                                </Disclosure.Button>
                            </dt>
                            <Disclosure.Panel as="dd" className="mt-2 pr-12">
                                <p className="text-base text-gray-500">{faq.answer}</p>
                            </Disclosure.Panel>
                        </>
                    )}
                </Disclosure>
            ))}
        </dl>

    )


}